// MessageShortcut.jsx
import React, { useState, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';

// --- Firebase (คงตามเดิม) ---
const firebaseConfig = {
  apiKey: "AIzaSyBALO-oNqvxmRhTSx9S54A5PIilTrxVOYM",
  authDomain: "refinery-desk-dashboard.firebaseapp.com",
  projectId: "refinery-desk-dashboard",
  storageBucket: "refinery-desk-dashboard.firebasestorage.app",
  messagingSenderId: "28035012838",
  appId: "1:28035012838:web:eb80f171a10371cdbec327"
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// ----------------------------------------------------
// Practical Shortcut
// - การ์ด: Title + Caption + ปุ่ม Send
// - การ์ดแรก = คอนเฟิร์มคิว (ฟอร์ม + Service Picker Modal + Copy ลงคิว)
// - การ์ดสอง = แก้คิว (ฟอร์ม + Service Picker Modal)
// - การ์ดอื่น = Preview + Send
// ----------------------------------------------------
const SHEET_TITLE = 'Message Shortcut (Thai)';
const FIRST_CARD_ID = 'confirmQueue'; // การ์ดแรก: คอนเฟิร์มคิว
const SECOND_CARD_ID = 'editQueue';    // การ์ดสอง: แก้คิว
const AFTERCARE_TEXT =
  'อันนี้จะเป็นรายละเอียดการดูแลตัวเอง ก่อน-หลัง เข้ารับบริการนะคะ\nhttps://rfn.clinic/suggestion';

// ข้อมูล Flex Map (ตัวอย่าง)
const MAP_CARD = {
  title: 'PHETCHABURI THONGLOR',
  subtitle: 'ติดถนนเพชรบุรีตัดใหม่ หยุดทุกวันจันทร์\nเปิด 11:00 - 20:00 น.',
  imageUrl:
    'https://firebasestorage.googleapis.com/v0/b/refinery-desk-dashboard.firebasestorage.app/o/refinery-asset%2Fitem-shortcut%2F1669997734500-2jf3toEKlpqQleQik2NXxA47s85JQx0XnjAE0Oznu7ZchiSQui.jpg?alt=media',
  buttonLabel: 'ค้นหาเส้นทาง',
  buttonLink: 'https://rfn.clinic/w-thonglormaps',
  gmapsLink: 'https://goo.gl/maps/jdA7S5PrrM2XL2iv5',
};

// ✅ ปรับชุดข้อความได้ที่นี่ (การ์ดแรก–สองอยู่บนสุด)
const SHORTCUTS = [
  { id: FIRST_CARD_ID, title: 'Appointment Confirm', caption: 'ส่งสรุปนัดอัตโนมัติ พร้อมรายละเอียด', content: '' },
  { id: SECOND_CARD_ID, title: 'Appointment Edit', caption: 'แก้ไขนัดพร้อมส่งสรุปอัตโนมัติ', content: '' },

  {
    id: 'hello', title: 'Greeting (1)', caption: 'ทักทายลูกค้ามาตรฐาน',
    content: 'ดิรีไฟน์เนอรี่คลินิก สวัสดีค่ะ 😊'
  },
  {
    id: 'hello-2', title: 'Greeting (2)', caption: 'ทักทายลูกค้า + ถาม',
    content: 'ดิรีไฟน์เนอรี่คลินิก สวัสดีค่ะ 😊\nสนใจรายการไหนแจ้งแอดมินได้เลยนะคะ'
  },
  {
    id: 'credit', title: '0% Installment', caption: 'สรุปเงื่อนไขผ่อนชำระ',
    content: 'รายละเอียดโปรบัตรเครดิตเพิ่มเติมนะคะ\n\n– ค่าใช้จ่าย 4,000 บาทขึ้นไป ผ่อนชำระ 0% สูงสุด 6 เดือน\n– ค่าใช้จ่าย 20,000 บาทขึ้นไป ผ่อนชำระ 0% สูงสุด 10 เดือน\n\nสามารถใช้บัตรเครดิต Visa / Master หรือ JCB ของทุกธนาคารในไทยผ่อนได้เลยค่ะ'
  },
  {
    id: 'map', title: 'Thonglor Location', caption: 'ส่ง Google Maps',
    content: 'https://goo.gl/maps/jdA7S5PrrM2XL2iv5\n\nหากเดินทางโดยรถยนต์\nตัวคลินิกติดถนนเพชรบุรีตัดใหม่ มีที่จอดรถให้บริการฟรี\nจุดสังเกต: ทางเข้าติดกับธนาคารไทยพาณิชย์\n\nเดินทางด้วยรถไฟฟ้า\n– MRT สถานีเพชรบุรี ทางออก 1\n– BTS สถานีทองหล่อ ทางออก 3\nต่อวินมอเตอร์ไซค์ หรือแอปพลิเคชัน มายัง TCM หรือ Carpet Inter'
  },
  {
    id: 'deposit', title: 'Deposit THB 500', caption: 'ส่งเลขบัญชีโอนจอง',
    content: 'สามารถโอนชำระเข้าบัญชีนี้เป็นยอดโอนจอง 500 บาทได้เลยนะคะ\n\n131-8-73519-7\nGlam De Bangkok Co., Ltd\nบริษัท แกลม เดอ แบงคอค จำกัด\nธนาคารกสิกรไทย'
  },
  {
    id: 'info', title: 'Name Request', caption: 'ขอชื่อที่อยู่สำหรับลงนัด',
    content: 'รบกวนขอชื่อ-นามสกุล พร้อมเบอร์ติดต่อ ของคุณลูกค้าด้วยนะคะ แอดมินช่วยลงนัดให้ค่ะ'
  },
  {
    id: 'aftercare', title: 'Before/After Care', caption: 'ส่งลิงค์ดูแลตัวเอง',
    content: AFTERCARE_TEXT
  },
  {
    id: 'consult', title: 'Free Consult', caption: 'ส่งปรึกษาฟรี + ไม่มีเซลล์',
    content: 'ปกติเราจะให้พบแพทย์เพื่อปรึกษาและไม่มีค่าใช้จ่ายก่อนทำทุกเคสนะคะ โดยที่คลินิกจะไม่มีเซลล์ขายคอร์สค่ะ'
  },
  {
    id: 'dropin', title: 'Consult Invitation', caption: 'ส่งข้อความชวนมาปรึกษา',
    content: 'ลองเข้ามาปรึกษาคุณหมอก่อนได้นะคะ หากยังไม่ทำไม่เป็นไรเลยค่ะ'
  },
  {
    id: 'reserve', title: 'Deposit Campaign', caption: 'ส่งถามรับสิทธิ์โอนจอง',
    content: 'สนใจโอนจอง 500 บาท เพื่อรับสิทธิ์แคมเปญลูกค้าใหม่ด้วยไหมคะ\nสามารถใช้หักแทนเงินสดตอนชำระเงินได้ค่ะ\n\nหรือหากปรึกษาแล้วยังไม่ทำ แอดมินโอนยอดจองสิทธิ์คืนให้เต็มจำนวนนะคะ'
  },
  {
    id: 'queued', title: 'Appointment Done', caption: 'ลงคิวเรียบร้อย + ขอบคุณ',
    content: 'ดำเนินการลงคิวให้เรียบร้อยค่ะ\n\nขอบคุณที่ไว้วางใจให้ ดิ รีไฟน์เนอรี่คลินิกดูแลนะคะ 😊'
  },
  {
    id: 'numbing', title: 'Numbing ?', caption: 'สอบถามแปะยาชาจัดเคส',
    content: 'แอดมินขออนุญาตสอบถามข้อมูลเพิ่มเติมประกอบการลงคิวนะคะ\nคุณลูกค้าต้องการแปะยาชาก่อนทำ หรือสะดวกทำเลยแบบไม่แปะดีคะ?\n\nหากเลือกแปะ จะมีช่วงเวลารอประมาณ 40 นาทีระหว่างรอฤทธิ์ยาชา\n\nทางคลินิกสามารถดูแลได้ทั้งสองแบบนะคะ\nสามารถเลือกตามที่คุณลูกค้าสะดวกได้เลยค่ะ'
  },
  {
    id: 'doctor-cer', title: 'Doctor Certificate', caption: 'ส่งเลข ว. แพทย์',
    content: 'รายละเอียดหมายเลขที่ใบประกอบวิชาชีพเวชกรรมของแพทย์แต่ละท่านนะคะ\n\nคุณหมอบอม\nนพ.กษิณ วงชื่นสุนทร\nว.58690\n\nคุณหมอแพตตี้\nพญ.พิมพ์นิภา ชัยมงคลโรจน์\nว.66014\n\nคุณหมอเกริก\nนพ.เกริก ดีทิพย์ประเสริฐ\nว.58700'
  },
];

// ---------- Utilities ----------
const weekdayTh = ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'];
const toThaiDayName = (yyyy_mm_dd) => {
  const d = new Date(`${yyyy_mm_dd}T00:00:00+07:00`);
  return weekdayTh[d.getDay()];
};
const ddmmyyyy = (yyyy_mm_dd) => {
  const [y, m, d] = yyyy_mm_dd.split('-');
  return `${d}/${m}/${y}`;
};

// parser สำหรับข้อความคอนเฟิร์มเดิม (อัปเดตให้รองรับ 2 บรรทัด/ข้ามคำว่า "ปรึกษา")
function parseOldConfirm(text) {
  let serviceName = '';

  // 1) ตรวจว่ามี "ปรึกษา" ไหม (รองรับทั้ง "พร้อมปรึกษา" และ "ปรึกษา")
  const withConsult = /(?:พร้อม)?ปรึกษา/.test(text);

  // 2) ตรวจยาชา: ถ้ามี "ไม่แปะยาชา" ให้ถือเป็น false แม้จะมีคำว่าแปะยาชา
  let useNumbing = false;
  if (/ไม่แปะยาชา/.test(text)) useNumbing = false;
  else if (/แปะยาชา/.test(text)) useNumbing = true;

  // 3) หาไลน์ที่มี "เข้ารับบริการ"
  const lines = text.split(/\r?\n/);
  const svcLineIndex = lines.findIndex((l) => /เข้ารับบริการ/.test(l));

  if (svcLineIndex !== -1) {
    // ส่วนที่ตามหลัง "เข้ารับบริการ" ในบรรทัดเดียวกัน
    const after = lines[svcLineIndex].replace(/^.*?เข้ารับบริการ\s*/, '').trim();

    // ถ้า after มีชื่อบริการจริง ๆ (ไม่ใช่แค่คำว่า "ปรึกษา" หรือ "ทำ")
    if (after && !/^(พร้อมปรึกษา|ปรึกษา|ทำ)$/.test(after)) {
      serviceName = after;
    } else {
      // มองหาบรรทัดถัดไปที่เป็นชื่อบริการ (ข้ามบรรทัดว่าง/โน้ต/ยาชา/สรุป/คำขอบคุณ)
      for (let i = svcLineIndex + 1; i < lines.length; i++) {
        const candidate = lines[i].trim();
        if (!candidate) continue;
        if (
          /^(และต้องการแปะยาชาก่อนทำ|ทำแบบไม่แปะยาชา|พร้อมรับสิทธิ์|หมายเหตุ|ดำเนินการ|ขอบคุณ|เวลา|วัน)/.test(candidate)
        ) continue;
        serviceName = candidate;
        break;
      }
    }
  }

  // 4) วันที่/เวลา (ให้ทนต่อการขึ้นบรรทัดใหม่)
  const dateMatch = text.match(/(\d{2}\/\d{2}\/\d{4})/);
  const timeMatch = text.match(/เวลา\s*([0-2]?\d:\d{2})/);

  const originalDate = dateMatch ? dateMatch[1] : null;
  const originalTime = timeMatch ? timeMatch[1] : null;

  return { serviceName, withConsult, useNumbing, originalDate, originalTime };
}


export default function MessageShortcut({ userId, selectedCustomer, onBack }) {
  const [successMessage, setSuccessMessage] = useState('');
  const [previewItem, setPreviewItem] = useState(null);
  const [sendingId, setSendingId] = useState(null);

  // -------- คอนเฟิร์มคิว (การ์ดแรก) --------
  const [dateStr, setDateStr] = useState('');
  const [timeStr, setTimeStr] = useState('');
  const [serviceName, setServiceName] = useState('');
  const [withConsult, setWithConsult] = useState(true);
  const [useNumbing, setUseNumbing] = useState(false);
  const [note, setNote] = useState('');
  const [newCustCampaignPaid, setNewCustCampaignPaid] = useState(false);

  // >>> เพิ่มเติม: ตัวเลือก Copy ลงคิว
  const [sizeTag, setSizeTag] = useState('');          // 'S' | 'M' | 'L' | ''
  const [noFollowUp, setNoFollowUp] = useState(false); // ไม่แจ้ง F/U → ถ้าติ๊ก ให้ใส่ * ต่อท้าย [S/M/L]
  const [isNewCustomer, setIsNewCustomer] = useState(false); // ลูกค้าใหม่

  // -------- แก้คิว (การ์ดสอง) --------
  const [oldText, setOldText] = useState('');
  const [editService, setEditService] = useState('');
  const [editWithConsult, setEditWithConsult] = useState(false);
  const [editUseNumbing, setEditUseNumbing] = useState(false);
  const [newDateStr, setNewDateStr] = useState('');
  const [newTimeStr, setNewTimeStr] = useState('');

  // -------- Service Picker Modal (ใช้ได้ทั้งการ์ดแรก/สอง) --------
  // ✅ จัดกลุ่มแท็บตามที่ร้องขอ
  const SERVICE_GROUPS = {
    'Problem Type': [
      "ปัญหาผิวแห้งดูขาดน้ำ",
      "ปัญหาผิวหมองคล้ำ",
      "ปัญหารูขุมขนกว้าง",
      "ปัญหาผิวบอบบาง",
      "ปัญหาสิวอักเสบสิวอุดตัน",
      "ปัญหารอยดำรอยแดง",
      "ปัญหาหลุมสิว",
      "ปัญหาฝ้า กระ จุดด่างดำ",
      "ปัญหาสีผิวไม่สม่ำเสมอ",
      "ปัญหาใต้ตาคล้ำ",
      "ปัญหาถุงใต้ตา",
      "ปัญหาเบ้าตาลึก",
      "ปัญหาริ้วรอยรอบดวงตา",
      "ปัญหาผิวหย่อนคล้อย",
      "ปัญหาริ้วรอยบนใบหน้า",
      "ปัญหาแก้มเหนียงแน่น",
      "ปัญหากรามใหญ่หน้าไม่เรียว",
      "ปัญหาไขมันส่วนเกินเฉพาะจุด (ลำตัว)",
      "ปัญหาผมบาง/ผมร่วง",
    ],
    'Botox': [
      'Botox (Bottle)',
      'Botox (Jawline)',
      'Botox (Wrinkle Refine)',
      'Botox (Lifting)',
      'Botox (Armpit)',
      'Botox (Calf)',
      'Botox (Nose)',
      'Botox (Shoulder)',
    ],
    'Hair Removal Laser': [
      "Armpits Hair Removal",
      "Face Hair Removal",
      "Body Hair Removal",
      "Arms Hair Removal",
      "Legs Hair Removal",
      "Buttock Hair Removal",
      "Brazilian Hair Removal",
      "Bikini Hair Removal",
      "Whole Body Hair Removal",
    ],
    'IV Drip Therapy': [
      "(IV) No.1 Beauty & Whitening",
      "(IV) No.2 Brain Refreshing",
      "(IV) No.3 Immunity Enhancing",
      "(IV) No.4 Energy Booster",
      "(IV) No.5 Fat Burning",
      "(IV) No.6 Recovery & Rejuvenating",
      "(IV) No.7 The Hang is Over",
      "(IV) The Brilliance Brightening",
      "(IV) Regenerating Elixir",
      'NAD+ IV Drip Therapy',
    ],
    'Mesotherapy': [
      "The Skin Refinement",
      "The Skin Refinement II",
      "The Originate Made Collagen",
      "Refinery Skin Strengthening",
      "Belotero Revive",
      "Chanel 2nd Gen",
      "Exoblanc",
      "The Filorga Skin Fulfilling",
      "Juvelook",
      "No.5 Refinery Skin Booster",
      "Rejuran",
      "Sculptra",
    ],
    'Standard Services': [
      'Acne Scar Refining',
      'Botox',
      'Fractora Glow (CO²)',
      'Filler',
      'Filler (Undereyes)',
      'Filler (Lips)',
      'Filler (Temple)',
      'Filler (Sunken Cheek)',
      'Hair Revival',
      'Meso Fat (Face)',
      'Meso Fat (Body)',
      'PRP (Platelet-Rich Plasma)',
      'Refinery Skin Radiance (RSR)',
      'Oligio',
      'Ultraformer III',
    ],
    'Treatment': [
      '(Laser) Acne & Spot Repairing',
      '(Laser) Enchated Facial Skin Refinement',
      "(Treatment) Say Goodbye to Acne (Pimple Clear)",
      "(Treatment) Say Goodbye to Melasma",
      "(Treatment) Refinery's Beautiology Secret",
    ],
    'Tier Privilege': [
      "[Silver Gift] IV Drip 1 of 7 Formula",
      "[Silver Gift] (Treatment) Say Goodbye to Acne",
      "[Silver Gift] (Laser) Enchated Facial Skin Refinement",
      '[Black Gift] Ultraformer III 200 Shots',
      "[Black Gift] Refinery's Meso Fat",
      "[Black Gift] The Skin Refinement",
      '[Black Monthly] IV - No.6 Recovery & Rejuvenating',
    ],
  };
  const TABS = Object.keys(SERVICE_GROUPS);
  const [showServicePicker, setShowServicePicker] = useState(false);
  const [servicePickerTarget, setServicePickerTarget] = useState(null); // 'confirm' | 'edit'
  const [tempServiceSelection, setTempServiceSelection] = useState([]); // ชุดที่ติ๊กไว้ใน modal
  const [serviceSearch, setServiceSearch] = useState('');
  const [activeTab, setActiveTab] = useState(TABS[0]);

  const scrollRef = useRef(null);

  const getScrollableParent = (el) => {
    let node = el;
    while (node && node !== document.body) {
      const { overflowY } = window.getComputedStyle(node);
      if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
      node = node.parentElement;
    }
    return window;
  };
  const scrollToTop = () => {
    const target = getScrollableParent(scrollRef.current);
    (target === window ? window : target).scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ------- LINE / Firestore helpers -------
  const logToFirestore = async (text) => {
    const latestCustomerInfo = selectedCustomer || {};
    await addDoc(collection(db, 'messages'), {
      from: 'me',
      role: 'me',
      userId,
      type: 'text',
      customer: text,
      createdAt: serverTimestamp(),
      displayName: latestCustomerInfo.displayName || 'Customer',
      pictureUrl: latestCustomerInfo.pictureUrl || '',
    });
  };
  const sendToLine = async (text) => {
    const res = await fetch('https://therefineryclinic.herokuapp.com/sendToLine', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, message: text }),
    });
    const result = await res.json();
    if (!result.success) throw new Error(result.error || 'ส่ง LINE ไม่สำเร็จ');
  };
  const sendFlexMap = async (card) => {
    const flexMessage = {
      type: 'flex',
      altText: card.title,
      contents: {
        type: 'bubble',
        hero: { type: 'image', url: card.imageUrl, size: 'full', aspectRatio: '16:10', aspectMode: 'cover' },
        body: {
          type: 'box', layout: 'vertical', spacing: 'sm',
          contents: [
            { type: 'text', text: card.title, weight: 'bold', size: 'lg', wrap: true },
            { type: 'text', text: card.subtitle, size: 'sm', color: '#555555', wrap: true },
          ],
        },
        footer: {
          type: 'box', layout: 'vertical', spacing: 'sm',
          contents: [{ type: 'button', style: 'link', height: 'sm', action: { type: 'uri', label: card.buttonLabel, uri: card.buttonLink } }],
          flex: 0,
        },
      },
    };
    const res = await fetch('https://therefineryclinic.herokuapp.com/sendFlexMessage', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, flexMessage }),
    });
    const result = await res.json();
    if (!result.success) throw new Error(result.error || 'ส่ง LINE ไม่สำเร็จ');
    await logToFirestore(`[CARD] ${card.title}`);
  };
  const sendAndLogText = async (text, idForLock) => {
    try {
      setSendingId(idForLock || 'inline');
      await sendToLine(text);
      await logToFirestore(text);
      setSuccessMessage(`ส่งข้อความสำเร็จ:\n${text}`);
      setPreviewItem(null);
      setTimeout(() => setSuccessMessage(''), 1800);
    } catch (err) {
      console.error('❌ LINE ERROR:', err);
      alert('❌ ไม่สามารถส่งข้อความผ่าน LINE ได้');
    } finally {
      setSendingId(null);
    }
  };

  // ------- คอนเฟิร์มคิว: compose & flows -------
  const formatConfirmMessage = () => {
    if (!dateStr || !timeStr || !serviceName) return null;
    const dayName = toThaiDayName(dateStr);
    const line1 = `ขออนุญาตคอนเฟิร์มคิวค่ะ\nวัน${dayName} ที่ ${ddmmyyyy(dateStr)}\nเวลา ${timeStr} น.\n`;
    const line2 = `เข้ารับบริการ${withConsult ? 'ปรึกษา\n' : 'ทำ\n'}${serviceName}`;
    const line3 = newCustCampaignPaid ? '\nพร้อมรับสิทธิ์แคมเปญลูกค้าใหม่\n(โอนจองแล้ว)' : '';
    const line4 = useNumbing ? 'และต้องการแปะยาชาก่อนทำ' : '';
    const lineNote = note?.trim() ? `\nหมายเหตุ: ${note.trim()}` : '';
    const summary = '\nดำเนินการลงคิวให้เรียบร้อยค่ะ\nขอบคุณที่ไว้วางใจให้ ดิ รีไฟน์เนอรี่คลินิกดูแลนะคะ 😊 ';
    return [line1, '', line2, line4, line3, lineNote, summary].filter(Boolean).join('\n');
  };

  // >>> บรรทัดสรุปสำหรับ Copy ลงระบบคิว (อัปเดต: รองรับ "แปะยาชา")
  const formatCopyQueueLine = () => {
    // parts เรียงลำดับ: ลูกค้าใหม่ -> แปะยาชา -> บริการ -> สิทธิ์โอนจอง
    const parts = [];
    if (isNewCustomer) parts.push('ลูกค้าใหม่');
    if (useNumbing) parts.push('แปะยาชา');
    if (serviceName) {
      parts.push(`${withConsult ? 'ปรึกษา ' : ''}${serviceName}`.trim());
    }
    if (newCustCampaignPaid) {
      parts.push('พร้อมรับสิทธิ์แคมเปญลูกค้าใหม่ (โอนจองแล้ว)');
    }

    const body = parts.join(' / ');
    if (!body) return '';

    const prefix = sizeTag ? `[${sizeTag}]${noFollowUp ? '*' : ''}` : '';
    return prefix ? `${prefix} ${body}` : body;
  };

  const sendFlowNormal = async () => {
    const msg = formatConfirmMessage();
    if (!msg) return alert('กรุณากรอก วันที่ เวลา และบริการ ให้ครบก่อนค่ะ');
    setSendingId('confirm-normal');
    try {
      await sendToLine(AFTERCARE_TEXT); await logToFirestore(AFTERCARE_TEXT);
      await sendToLine(msg); await logToFirestore(msg);
      setSuccessMessage('ส่งคอนเฟิร์มคิว (ปกติ) สำเร็จ');
      setPreviewItem(null);
      setTimeout(() => setSuccessMessage(''), 1800);
    } catch (e) { console.error(e); alert('❌ ส่งคอนเฟิร์มคิวไม่สำเร็จ'); }
    finally { setSendingId(null); }
  };
  const sendFlowWithMap = async () => {
    const msg = formatConfirmMessage();
    if (!msg) return alert('กรุณากรอก วันที่ เวลา และชื่อบริการ ให้ครบก่อนค่ะ');
    setSendingId('confirm-map');
    try {
      await sendFlexMap(MAP_CARD);
      const locationText = `Location Clinic (Google Maps):\nhttps://goo.gl/maps/jdA7S5PrrM2XL2iv5\n\nหากเดินทางโดยรถยนต์\nตัวคลินิกติดถนนเพชรบุรีตัดใหม่ มีที่จอดรถให้บริการฟรี\nจุดสังเกต: ทางเข้าติดกับธนาคารไทยพาณิชย์\n\nเดินทางด้วยรถไฟฟ้า\n– MRT สถานีเพชรบุรี ทางออก 1\n– BTS สถานีทองหล่อ ทางออก 3\nต่อวินมอเตอร์ไซค์ หรือแอปฯ มายัง TCM หรือ Carpet Inter`;
      await sendToLine(locationText); await logToFirestore(locationText);
      await sendToLine(AFTERCARE_TEXT); await logToFirestore(AFTERCARE_TEXT);
      await sendToLine(msg); await logToFirestore(msg);
      setSuccessMessage('ส่งคอนเฟิร์มคิว + แผนที่ สำเร็จ');
      setPreviewItem(null);
      setTimeout(() => setSuccessMessage(''), 1800);
    } catch (e) { console.error(e); alert('❌ ส่งคอนเฟิร์มคิว + แผนที่ ไม่สำเร็จ'); }
    finally { setSendingId(null); }
  };

  // ------- แก้คิว: compose & send -------
  const formatEditConfirmMessage = () => {
    if (!newDateStr || !newTimeStr || !editService) return null;
    const dayName = toThaiDayName(newDateStr);
    const line1 = `ขออนุญาตคอนเฟิร์มคิวใหม่นะคะ`;
    const line2 = `วัน${dayName} ที่ ${ddmmyyyy(newDateStr)}\nเวลา ${newTimeStr} น.\n`;
    const line3 = `เข้ารับบริการ${editWithConsult ? 'ปรึกษา\n' : 'ทำ\n'}${editService}`;
    const line4 = `${editUseNumbing ? 'และต้องการแปะยาชาก่อนทำ\n' : ''}`;
    const tail = `\nดำเนินการแก้ไขคิวให้เรียบร้อยค่ะ\nขอบคุณที่ไว้วางใจให้ ดิ รีไฟน์เนอรี่คลินิกดูแลนะคะ 😊`;
    // เว้นบรรทัดให้ใกล้เคียงตัวอย่าง
    return [line1, line2, line3, line4].join('\n') + tail;
  };
  const sendEditFlow = async () => {
    const msg = formatEditConfirmMessage();
    if (!msg) return alert('กรุณากรอก วัน–เวลา และบริการใหม่ให้ครบก่อนค่ะ');
    setSendingId('edit-queue');
    try {
      await sendToLine(msg); await logToFirestore(msg);
      setSuccessMessage('ส่งข้อความแก้คิวสำเร็จ');
      setPreviewItem(null);
      setTimeout(() => setSuccessMessage(''), 1800);
    } catch (e) { console.error(e); alert('❌ ส่งข้อความแก้คิวไม่สำเร็จ'); }
    finally { setSendingId(null); }
  };

  // ------- Service Picker logic -------
  const parseServicesFromField = (val) =>
    (val || '')
      .split('/')
      .map(s => s.trim())
      .filter(Boolean);

  const openServicePicker = (target /* 'confirm'|'edit' */) => {
    const current = target === 'confirm' ? serviceName : editService;
    const currentList = parseServicesFromField(current);
    setTempServiceSelection(currentList);
    setServicePickerTarget(target);
    setServiceSearch('');
    setShowServicePicker(true);
  };

  const toggleTempService = (name) => {
    setTempServiceSelection((prev) => {
      const exists = prev.some(s => s.toLowerCase() === name.toLowerCase());
      if (exists) return prev.filter(s => s.toLowerCase() !== name.toLowerCase());
      return [...prev, name];
    });
  };

  const applyServiceSelection = () => {
    const joined = tempServiceSelection.join(' / ');
    if (servicePickerTarget === 'confirm') {
      setServiceName(joined || '');
    } else if (servicePickerTarget === 'edit') {
      setEditService(joined || '');
    }
    setShowServicePicker(false);
  };

  // รายการในแท็บปัจจุบัน + ค้นหา
  const currentTabList = (SERVICE_GROUPS[activeTab] || []);
  const listToShow = currentTabList.filter(s =>
    s.toLowerCase().includes(serviceSearch.trim().toLowerCase())
  );

  // ------- UI -------
  return (
    <div ref={scrollRef} className="relative max-w-screen-xl mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center mt-[-2px] mb-4">
        <div className="flex items-center gap-3">
          <h3 className="text-lg font-semibold">{SHEET_TITLE}</h3>
          <button onClick={onBack} className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition">← Back</button>
        </div>
      </div>

      {/* Grid 3 columns */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
        {SHORTCUTS.map((item) => (
          <div key={item.id} className="border border-gray-200 rounded-xl p-4 bg-white shadow-sm hover:shadow transition">
            <div className="flex items-start justify-between gap-3">
              {/* Title + Caption */}
              <button
                type="button"
                onClick={() => {
                  if (item.id === FIRST_CARD_ID) {
                    // reset form (คอนเฟิร์มคิว)
                    setDateStr(''); setTimeStr('');
                    setServiceName('');
                    setWithConsult(true); setUseNumbing(false);
                    setNote(''); setNewCustCampaignPaid(false);
                    // reset ตัวเลือก Copy ลงคิว
                    setSizeTag(''); setNoFollowUp(false); setIsNewCustomer(false);

                    setPreviewItem(item);
                  } else if (item.id === SECOND_CARD_ID) {
                    // reset form (แก้คิว)
                    setOldText(''); setEditService('');
                    setEditWithConsult(false); setEditUseNumbing(false);
                    setNewDateStr(''); setNewTimeStr('');
                    setPreviewItem(item);
                  } else {
                    setPreviewItem(item);
                  }
                }}
                className="text-left"
                title={(item.id === FIRST_CARD_ID) ? 'คอนเฟิร์มคิว' : (item.id === SECOND_CARD_ID ? 'แก้คิว' : 'Preview ข้อความนี้')}
                aria-label={(item.id === FIRST_CARD_ID) ? 'คอนเฟิร์มคิว' : (item.id === SECOND_CARD_ID ? 'แก้คิว' : 'Preview ข้อความนี้')}
              >
                <div className="text-sm font-semibold leading-snug">{item.title}</div>
                {item.caption && <div className="text-xs text-gray-500 mt-0.5">{item.caption}</div>}
              </button>

              {/* Quick Send: ซ่อนในการ์ดฟอร์ม (แรก+สอง) */}
              {item.id !== FIRST_CARD_ID && item.id !== SECOND_CARD_ID && (
                <button
                  type="button"
                  onClick={() => sendAndLogText(item.content, item.id)}
                  disabled={sendingId === item.id}
                  className={`px-3 py-1 text-xs rounded-full border transition ${sendingId === item.id ? 'bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed' : 'border-gray-300 text-gray-700 hover:bg-gray-100'}`}
                  title="ส่งข้อความนี้ทันที"
                >
                  {sendingId === item.id ? 'Sending…' : 'Send'}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Preview Modal */}
      {previewItem && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          {/* กล่องหลัก: จำกัดความสูง + แบ่งส่วน + กันล้นจอเล็ก */}
          <div className="bg-white rounded-2xl shadow-xl w-[92vw] max-w-[840px] max-h-[86vh] overflow-hidden flex flex-col">
            {/* Header (sticky) */}
            <div className="px-5 py-4 border-b bg-white sticky top-0 z-10 flex items-start justify-between gap-3">
              <div>
                <div className="text-sm font-semibold">{previewItem.title}</div>
                {previewItem.caption && <div className="text-xs text-gray-500">{previewItem.caption}</div>}
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setPreviewItem(null)}
                  className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 hover:bg-gray-100"
                >
                  ✕ Close
                </button>
              </div>
            </div>

            {/* Body (เลื่อนในตัวเอง) */}
            <div className="px-5 py-4 flex-1 overflow-y-auto overscroll-contain">
              {/* --- การ์ดทั่วไป (ไม่ใช่ฟอร์ม) --- */}
              {previewItem.id !== FIRST_CARD_ID && previewItem.id !== SECOND_CARD_ID && (
                <>
                  <div className="text-sm text-gray-800 whitespace-pre-line border border-gray-200 rounded-xl p-3 bg-gray-50">
                    {previewItem.content}
                  </div>

                  {/* Footer ปุ่ม (sticky ล่าง) */}
                  <div className="sticky bottom-0 bg-white pt-4 mt-4">
                    <div className="border-t pt-4 flex items-center justify-end gap-3">
                      <button
                        onClick={() => setPreviewItem(null)}
                        className="px-4 py-1 text-sm border border-gray-300 rounded-full text-gray-600 hover:bg-gray-100"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={() => sendAndLogText(previewItem.content, previewItem.id)}
                        disabled={sendingId === previewItem.id}
                        className={`px-4 py-1 text-sm rounded-full transition ${sendingId === previewItem.id ? 'bg-gray-300 text-white cursor-not-allowed' : 'bg-black text-white hover:opacity-90'
                          }`}
                      >
                        {sendingId === previewItem.id ? 'Sending…' : 'Send'}
                      </button>
                    </div>
                  </div>
                </>
              )}

              {/* --- การ์ดแรก: คอนเฟิร์มคิว (ฟอร์ม) --- */}
              {previewItem.id === FIRST_CARD_ID && (
                <>
                  {/* เนื้อหาเดิมของฟอร์มคอนเฟิร์มคิว (เหมือนเดิมทุกบรรทัด) */}
                  <div className="border border-gray-200 rounded-xl p-4 bg-gray-50">
                    {/* ... (ฟอร์มวันที่/เวลา/บริการ/เช็คบ็อกซ์/หมายเหตุ เดิมของคุณทั้งหมด) ... */}
                    {/* ใช้บล็อกเดิมจากไฟล์ของคุณได้เลย ไม่ต้องเปลี่ยนอะไร */}
                    {/* >>> เริ่มฟอร์มเดิม >>> */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Date (yyyy-mm-dd)</label>
                        <input type="date" value={dateStr} onChange={(e) => setDateStr(e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm" />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Time (HH:mm)</label>
                        <input type="time" value={timeStr} onChange={(e) => setTimeStr(e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm" step="60" pattern="[0-9]{2}:[0-9]{2}" />
                      </div>

                      <div className="md:col-span-2">
                        <label className="block text-xs text-gray-600 mb-1">Services (multi-select)</label>
                        <div className="flex gap-2">
                          <input
                            type="text"
                            readOnly
                            value={serviceName}
                            onClick={() => openServicePicker('confirm')}
                            placeholder="Click to select services"
                            className="w-full border rounded-lg px-3 py-2 text-sm bg-white cursor-pointer"
                          />
                          <button
                            type="button"
                            onClick={() => openServicePicker('confirm')}
                            className="px-3 py-2 text-sm rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100"
                          >
                            Pick
                          </button>
                        </div>
                        <div className="text-[11px] text-gray-500 mt-1">Supports selecting multiple services</div>
                      </div>
                    </div>

                    <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
                      <label className="flex items-center gap-2 text-sm">
                        <input type="checkbox" checked={withConsult} onChange={(e) => setWithConsult(e.target.checked)} />
                        With consultation
                      </label>
                      <label className="flex items-center gap-2 text-sm">
                        <input type="checkbox" checked={useNumbing} onChange={(e) => setUseNumbing(e.target.checked)} />
                        Apply numbing cream
                      </label>
                      <label className="flex items-center gap-2 text-sm">
                        <input type="checkbox" checked={newCustCampaignPaid} onChange={(e) => setNewCustCampaignPaid(e.target.checked)} />
                        New customer campaign deposit paid
                      </label>
                    </div>

                    <div className="mt-4">
                      <label className="block text-xs text-gray-600 mb-1">Additional notes</label>
                      <textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm" placeholder="Add any notes for the customer (if any)" />
                    </div>
                  </div>

                  <div className="mt-4 text-xs text-gray-500">Message preview to send:</div>
                  <div className="mt-2 text-sm text-gray-800 whitespace-pre-line border border-gray-200 rounded-xl p-3">
                    {formatConfirmMessage() || 'Enter the date, time, and select services to see the summary preview'}
                  </div>

                  {/* คิวคัดลอก (เดิม) */}
                  <div className="mt-6 border border-dashed rounded-xl p-4">
                    {/* ... (บล็อก Copy ลงคิว เดิมทั้งหมดของคุณ) ... */}
                    {/* <<< จบฟอร์มเดิม <<< */}
                    <div className="text-sm font-medium mb-2">Queue-entry copy</div>

                    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm mb-3">
                      <label className="inline-flex items-center gap-2 cursor-pointer">
                        <input type="checkbox" checked={sizeTag === 'S'} onChange={() => setSizeTag(sizeTag === 'S' ? '' : 'S')} />
                        [S]
                      </label>
                      <label className="inline-flex items-center gap-2 cursor-pointer">
                        <input type="checkbox" checked={sizeTag === 'M'} onChange={() => setSizeTag(sizeTag === 'M' ? '' : 'M')} />
                        [M]
                      </label>
                      <label className="inline-flex items-center gap-2 cursor-pointer">
                        <input type="checkbox" checked={sizeTag === 'L'} onChange={() => setSizeTag(sizeTag === 'L' ? '' : 'L')} />
                        [L]
                      </label>

                      <div className="h-4 w-px bg-gray-300 mx-1 hidden sm:block" />

                      <label className="inline-flex items-center gap-2 cursor-pointer">
                        <input type="checkbox" checked={noFollowUp} onChange={(e) => setNoFollowUp(e.target.checked)} />
                        Do not set F/U
                      </label>

                      <label className="inline-flex items-center gap-2 cursor-pointer">
                        <input type="checkbox" checked={isNewCustomer} onChange={(e) => setIsNewCustomer(e.target.checked)} />
                        New customer
                      </label>
                    </div>

                    <div className="bg-gray-50 border rounded-lg p-3 text-sm whitespace-pre-wrap">
                      {formatCopyQueueLine() || '— Choose [S/M/L], New customer, etc., and the summary will appear here —'}
                    </div>

                    <div className="mt-3 flex justify-end">
                      <button
                        type="button"
                        onClick={() => {
                          const line = formatCopyQueueLine();
                          if (!line) return;
                          navigator.clipboard.writeText(line);
                        }}
                        disabled={!formatCopyQueueLine()}
                        className="px-3 py-1 text-xs rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100 disabled:opacity-50"
                      >
                        Copy
                      </button>
                    </div>
                  </div>

                  {/* Footer ปุ่มส่ง (sticky ล่าง) */}
                  <div className="sticky bottom-0 bg-white pt-4 mt-4">
                    <div className="border-t pt-4 flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-3">
                      <button
                        onClick={sendFlowNormal}
                        disabled={sendingId === 'confirm-normal'}
                        className={`px-4 py-1 text-sm rounded-full transition ${sendingId === 'confirm-normal' ? 'bg-gray-300 text-white cursor-not-allowed' : 'bg-black text-white hover:opacity-90'
                          }`}
                        title="ส่ง: ลิงก์ดูแลตัวเอง → คอนเฟิร์มคิว"
                      >
                        {sendingId === 'confirm-normal' ? 'Sending…' : 'Send Appointment (Standard)'}
                      </button>
                      <button
                        onClick={sendFlowWithMap}
                        disabled={sendingId === 'confirm-map'}
                        className={`px-4 py-1 text-sm rounded-full transition ${sendingId === 'confirm-map' ? 'bg-gray-300 text-white cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'
                          }`}
                        title="ส่ง: Flex Map → Google Maps → ลิงก์ดูแลตัวเอง → คอนเฟิร์มคิว"
                      >
                        {sendingId === 'confirm-map' ? 'Sending…' : 'Send Appointment (+ Maps)'}
                      </button>
                    </div>
                  </div>
                </>
              )}

              {/* --- การ์ดสอง: แก้คิว (ฟอร์ม) --- */}
              {previewItem.id === SECOND_CARD_ID && (
                <>
                  {/* เนื้อหาเดิมของฟอร์มแก้คิว */}
                  <div className="border border-gray-200 rounded-xl p-4 bg-gray-50">
                    {/* ... (ฟอร์มเดิมของคุณทั้งหมด) ... */}
                    <label className="block text-xs text-gray-600 mb-1">Paste the previous confirmation</label>
                    <textarea
                      rows={5}
                      value={oldText}
                      onChange={(e) => {
                        const val = e.target.value;
                        setOldText(val);
                        const parsed = parseOldConfirm(val);
                        setEditService((prev) => prev || parsed.serviceName);
                        setEditWithConsult(parsed.withConsult);
                        setEditUseNumbing(parsed.useNumbing);
                      }}
                      className="w-full border rounded-lg px-3 py-2 text-sm"
                      placeholder={`Paste the previous message, e.g.\n\nขออนุญาตคอนเฟิร์มคิววันเสาร์ ที่ 16/08/2025 เวลา 00:19\n\nเข้ารับบริการ Ultraformer III\n\nทำแบบไม่แปะยาชา\n\nดำเนินการลงคิวให้เรียบร้อยค่ะ\nขอบคุณที่ไว้วางใจให้ ดิ รีไฟน์เนอรี่คลินิกดูแลนะคะ 😊`}
                    />

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">New date (yyyy-mm-dd)</label>
                        <input type="date" value={newDateStr} onChange={(e) => setNewDateStr(e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm" />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">New time (HH:mm)</label>
                        <input type="time" value={newTimeStr} onChange={(e) => setNewTimeStr(e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm" step="60" pattern="[0-9]{2}:[0-9]{2}" />
                      </div>

                      <div className="md:col-span-2">
                        <label className="block text-xs text-gray-600 mb-1">Services</label>
                        <div className="flex gap-2">
                          <input
                            type="text"
                            readOnly
                            value={editService}
                            onClick={() => openServicePicker('edit')}
                            placeholder="Click to select services"
                            className="w-full border rounded-lg px-3 py-2 text-sm bg-white cursor-pointer"
                          />
                          <button
                            type="button"
                            onClick={() => openServicePicker('edit')}
                            className="px-3 py-2 text-sm rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100"
                          >
                            เลือก
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
                      <label className="flex items-center gap-2 text-sm">
                        <input type="checkbox" checked={editWithConsult} onChange={(e) => setEditWithConsult(e.target.checked)} />
                        With consultation
                      </label>
                      <label className="flex items-center gap-2 text-sm">
                        <input type="checkbox" checked={editUseNumbing} onChange={(e) => setEditUseNumbing(e.target.checked)} />
                        Apply numbing cream
                      </label>
                    </div>
                  </div>

                  <div className="mt-4 text-xs text-gray-500">Preview of the edit message:</div>
                  <div className="mt-2 text-sm text-gray-800 whitespace-pre-line border border-gray-200 rounded-xl p-3">
                    {formatEditConfirmMessage() || 'Paste the previous message, set the new date & time, and select services to preview the message'}
                  </div>

                  {/* Footer ปุ่มส่ง (sticky ล่าง) */}
                  <div className="sticky bottom-0 bg-white pt-4 mt-4">
                    <div className="border-t pt-4 flex items-center justify-end gap-3">
                      <button
                        onClick={sendEditFlow}
                        disabled={sendingId === 'edit-queue'}
                        className={`px-4 py-1 text-sm rounded-full transition ${sendingId === 'edit-queue' ? 'bg-gray-300 text-white cursor-not-allowed' : 'bg-black text-white hover:opacity-90'
                          }`}
                      >
                        {sendingId === 'edit-queue' ? 'Sending…' : 'Send edited appointment'}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}


      {/* Success Alert */}
      {successMessage && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="bg-white shadow-xl rounded-xl px-6 py-4 border border-gray-200 text-center max-w-sm w-[92vw]">
            <div className="text-sm text-gray-800 mb-3 whitespace-pre-line">{successMessage}</div>
            <button onClick={() => setSuccessMessage('')} className="text-xs px-3 py-1 border border-gray-300 rounded-full hover:bg-gray-100 transition text-gray-500">ปิด</button>
          </div>
        </div>
      )}

      {/* Footer Controls */}
      <div className="mt-6 flex justify-between items-center">
        <button onClick={onBack} className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition">← Back</button>
        <button onClick={scrollToTop} className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition">↑ Top</button>
      </div>

      {/* ---------- Service Picker Modal ---------- */}
      {showServicePicker && (
        <div className="fixed inset-0 bg-black/50 z-[70] flex items-center justify-center">
          <div className="bg-white rounded-2xl shadow-xl w-[96vw] max-w-[960px] p-5">
            <div className="flex items-center justify-between">
              <div className="font-semibold text-sm">Select Services (multi-select)</div>
              <button
                onClick={() => setShowServicePicker(false)}
                className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 hover:bg-gray-100"
              >
                ✕ Close
              </button>
            </div>

            {/* Tabs (2 แถว + wrap) */}
            <div className="mt-4">
              <div className="flex flex-wrap gap-2 w-full max-h-[72px] overflow-y-auto pr-1">
                {TABS.map((tab) => {
                  const isActive = tab === activeTab;
                  return (
                    <button
                      key={tab}
                      type="button"
                      onClick={() => setActiveTab(tab)}
                      className={`px-3 py-1.5 text-xs rounded-full border whitespace-nowrap transition
            ${isActive ? 'bg-black text-white border-black' : 'border-gray-300 text-gray-700 hover:bg-gray-100'}`}
                    >
                      {tab}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Search */}
            <div className="mt-3">
              <input
                type="text"
                value={serviceSearch}
                onChange={(e) => setServiceSearch(e.target.value)}
                placeholder={`Search in "${activeTab}"`}
                className="w-full border rounded-lg px-3 py-2 text-sm"
              />
            </div>

            {/* List */}
            <div className="mt-4 max-h-[44vh] overflow-auto border rounded-xl p-3">
              {listToShow.length === 0 && (
                <div className="text-xs text-gray-500">No items in this tab (or no matches)</div>
              )}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
                {listToShow.map((name) => {
                  const checked = tempServiceSelection.some(s => s.toLowerCase() === name.toLowerCase());
                  return (
                    <label key={name} className="flex items-center gap-2 text-sm cursor-pointer px-2 py-1 rounded hover:bg-gray-50">
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => toggleTempService(name)}
                      />
                      <span className="truncate">{name}</span>
                    </label>
                  );
                })}
              </div>
            </div>

            {/* Selected preview */}
            <div className="mt-3 text-xs text-gray-500">Selected:</div>
            <div className="mt-1 text-sm text-gray-800 min-h-[2rem] border rounded-lg px-3 py-2 bg-gray-50">
              {tempServiceSelection.length ? tempServiceSelection.join(' / ') : '—'}
            </div>

            <div className="mt-5 flex items-center justify-end gap-3">
              <button
                onClick={() => setTempServiceSelection([])}
                className="px-4 py-1 text-sm border border-gray-300 rounded-full text-gray-600 hover:bg-gray-100"
              >
                Clear All
              </button>
              <button
                onClick={applyServiceSelection}
                className="px-4 py-1 text-sm rounded-full bg-black text-white hover:opacity-90"
              >
                Apply Selection
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
